import { useState, useEffect } from 'react';
import { subscribe } from '../../../services/utils/pubsub';
import { ComponentEvents } from '../../../services/wss/events/ComponentEvents';
import { EngineNames } from '../../../services/wss/events/EngineNames';
import searchEngine from './Core/SearchEngine';

/**
 * Paint hook for SearchEngine.
 * Returns current results state — all mutations via searchEngine directly.
 */
export default function useSearchResults() {
    const [state, setState] = useState({
        results: searchEngine.getResults(),
        total: searchEngine.getTotal(),
        page: searchEngine.getPage(),
        pageSize: searchEngine.getPageSize(),
        selectedEntry: searchEngine.getSelectedEntry(),
        loading: searchEngine.isLoading(),
    });

    useEffect(() => {
        return subscribe(ComponentEvents.channel, (e) => {
            if (e.name !== EngineNames.SearchEngine) return;
            if (e.target !== 'SearchResultReceived') return;
            setState({
                results: e.data.results,
                total: e.data.total,
                page: e.data.page,
                pageSize: e.data.pageSize,
                selectedEntry: e.data.selectedEntry,
                loading: e.data.loading,
            });
        });
    }, []);

    return state;
}
